<meta name="viewport" content="width=device-width, initial-scale=1.0">

<div class="container">
  <p class="firstp">
    It is time to change your password as per Complinity Security Policy.
  </p>
  <p class="secondp">
    An Email has been sent to you. It contains a 6 digit security code. You need to enter that in the box provided below
  </p>
</div>
<div class="reset-card">
  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

    <div class="grid">
      <!-- Password -->
      <div class="field col-6 password-field">
        <label class="required-label">New Password</label>

        <div class="input-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="New Password"
            formControlName="password"
            class="input-box"
            (input)="checkPasswordStrength();checkconfirmPassword()"
          />
          <i class="pi toggle-icon"
             [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
             (click)="togglePassword()"></i>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="field col-6 password-field">
        <label class="required-label">Confirm New Password</label>

        <div class="input-wrapper">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            placeholder="Confirm New Password"
            formControlName="confirmPassword"
            class="input-box"
            (input)="checkconfirmPassword()"
          />
          <i class="pi toggle-icon"
             [ngClass]="showConfirmPassword ? 'pi-eye-slash' : 'pi-eye'"
             (click)="toggleConfirmPassword()"></i>
        </div>
      </div>
    </div>

    <!-- OTP -->
    <div class="grid">
      <div class="field col-12">
        <label class="required-label">OTP (Security Code sent on email)</label>
        <input
          type="text"
          placeholder="Enter OTP"
          formControlName="otp"
          class="input-box"
        />
      </div>
    </div>

    <!-- Buttons -->
    <div class="button-group">
      <button type="submit" class="continue-btn"
              [disabled]="!resetForm.valid || !allRulesPassed()">
        Continue
      </button>
      <button class="cancel-btn" type="button" (click)="cancel()">Cancel</button>
    </div>

  </form>

  <!-- Rules -->
  <div class="rules-box">
    <p class="boldbalctext">Password must contain the following:</p>
    <ul>
      <li *ngFor="let rule of ruleList">
        <i class="pi"
           [ngClass]="rule.check ? 'pi-check-circle valid-icon' : 'pi-times-circle invalid-icon'"></i>
        <span [ngClass]="rule.check ? 'valid-text' : 'invalid-text'">
          {{ rule.label }}
        </span>
      </li>
    </ul>
  </div>
</div>